import { slicedToArray as _slicedToArray } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import _styled from '@emotion/styled/base';
import React__default, { useRef, useImperativeHandle, useEffect } from 'react';
import { useDrag } from 'react-dnd';
import { jsx } from '@emotion/react';
import { getEmptyImage } from '../../../../node_modules/react-dnd-html5-backend/dist/getEmptyImage.js';

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var RECTANGLE = 'RECTANGLE';
var DraggableRectangle = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var children = _ref.children;
  var rectangle = useRef(null);
  useImperativeHandle(ref, function () {
    return rectangle.current;
  });
  var _useDrag = useDrag({
      type: RECTANGLE
    }),
    _useDrag2 = _slicedToArray(_useDrag, 3),
    drag = _useDrag2[1],
    preview = _useDrag2[2];
  drag(rectangle);
  useEffect(function () {
    preview(getEmptyImage());
  }, []);
  return jsx(Rectangle, {
    ref: rectangle
  }, children);
});
var Rectangle = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1i4rjv60"
} : {
  target: "e1i4rjv60",
  label: "Rectangle"
})(process.env.NODE_ENV === "production" ? {
  name: "177v39q",
  styles: "position:absolute;top:0;left:0;right:0;bottom:0;border:1px solid rgba(0, 0, 0, 0.04);background:rgba(0, 0, 0, 0.2);cursor:move;pointer-events:initial"
} : {
  name: "177v39q",
  styles: "position:absolute;top:0;left:0;right:0;bottom:0;border:1px solid rgba(0, 0, 0, 0.04);background:rgba(0, 0, 0, 0.2);cursor:move;pointer-events:initial",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkRyYWdnYWJsZVJlY3RhbmdsZS50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBMkI0QiIsImZpbGUiOiJEcmFnZ2FibGVSZWN0YW5nbGUudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0LCB7IHVzZUVmZmVjdCwgdXNlSW1wZXJhdGl2ZUhhbmRsZSwgdXNlUmVmIH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsgdXNlRHJhZyB9IGZyb20gJ3JlYWN0LWRuZCc7XG5pbXBvcnQgeyBnZXRFbXB0eUltYWdlIH0gZnJvbSAncmVhY3QtZG5kLWh0bWw1LWJhY2tlbmQnO1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuXG5leHBvcnQgY29uc3QgUkVDVEFOR0xFID0gJ1JFQ1RBTkdMRSc7XG5cbmludGVyZmFjZSBEcmFnZ2FibGVSZWN0YW5nbGVQcm9wcyB7XG4gIGNoaWxkcmVuOiBSZWFjdC5SZWFjdE5vZGU7XG59XG5cbmV4cG9ydCBjb25zdCBEcmFnZ2FibGVSZWN0YW5nbGUgPSBSZWFjdC5mb3J3YXJkUmVmPFxuSFRNTERpdkVsZW1lbnQsXG5EcmFnZ2FibGVSZWN0YW5nbGVQcm9wc1xuPigoeyBjaGlsZHJlbiB9LCByZWYpID0+IHtcbiAgY29uc3QgcmVjdGFuZ2xlID0gdXNlUmVmPEhUTUxEaXZFbGVtZW50PihudWxsKTtcbiAgdXNlSW1wZXJhdGl2ZUhhbmRsZShyZWYsICgpID0+IHJlY3RhbmdsZS5jdXJyZW50ISk7XG5cbiAgY29uc3QgWywgZHJhZywgcHJldmlld10gPSB1c2VEcmFnKHsgdHlwZTogUkVDVEFOR0xFIH0pO1xuICBkcmFnKHJlY3RhbmdsZSk7XG4gIHVzZUVmZmVjdCgoKSA9PiB7XG4gICAgcHJldmlldyhnZXRFbXB0eUltYWdlKCkpO1xuICB9LCBbXSk7XG5cbiAgcmV0dXJuIDxSZWN0YW5nbGUgcmVmPXtyZWN0YW5nbGV9PnsgY2hpbGRyZW4gfTwvUmVjdGFuZ2xlPjtcbn0pO1xuXG5jb25zdCBSZWN0YW5nbGUgPSBzdHlsZWQuZGl2YFxuICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gIHRvcDogMDtcbiAgbGVmdDogMDtcbiAgcmlnaHQ6IDA7XG4gIGJvdHRvbTogMDtcbiAgYm9yZGVyOiAxcHggc29saWQgcmdiYSgwLCAwLCAwLCAwLjA0KTtcbiAgYmFja2dyb3VuZDogcmdiYSgwLCAwLCAwLCAwLjIpO1xuICBjdXJzb3I6IG1vdmU7XG4gIHBvaW50ZXItZXZlbnRzOiBpbml0aWFsO1xuYDtcbiJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

export { DraggableRectangle, RECTANGLE };
//# sourceMappingURL=DraggableRectangle.js.map
